import React from "react";
import { PageLayout } from "../../../components";
import RegistrationInput from "../../../components/RegistrationInput";
import { useCheckRegistration } from "./useCheckRegistration";

export default function CheckRegistration() {
  const {
    error,
    errorMain,
    errorHint,
    primaryButtonText,
    secondaryButtonText,
    handleSubmit,
    handleRegChange,
    regInput,
    sourceSystem,
    showAltButton
  } = useCheckRegistration();

  return (
    <>
      <PageLayout>
        <PageLayout.Header title="Registration" step={1} />
        <div className="ch-container ch-mt--4 md:ch-width--4 sm:ch-width--5 ch-width--12 sl:ch-width--8 ">
          <div
            className="ch-alert ch-alert--warning ch-fs--3 "
            style={{ border: "solid 1px orange" }}
          >
            <p className="ch-text--bold">{errorMain}</p>
            <p>{errorHint}</p>
          </div>
          <RegistrationInput
            title="Registration"
            onChange={handleRegChange}
            placeholder="Registration"
            defaultValue={regInput}
            error={error}
          />
        </div>
        <div className="reg-error-page-layout--bottom-fixed ch-bg--grey-1 sm:ch-mt--10">
          <button
            className="ch-btn ch-btn--success ch-btn--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
            onClick={() => handleSubmit()}
          >
            {primaryButtonText}
          </button>
          {showAltButton && (
            <button
              className="ch-btn ch-btn--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
              onClick={() =>
                sourceSystem.vehicleNotFoundError.onClickVehicleNotFoundSecondary()
              }
            >
              {secondaryButtonText}
            </button>
          )}
        </div>
      </PageLayout>
    </>
  );
}
